'use client';

import React, { useMemo } from 'react';
import type { CuriosityParams } from '@/app/components/search/Curiosity';
import {
  createCuriosityClickEvents,
  type CuriosityClickEvents,
} from '@/app/components/search/Curiosity/createCuriosityClickEvents.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';

type CuriosityManagerProviderProps = {
  curiosityClickEvents: CuriosityClickEvents;
};

export const CuriosityManagerContext = React.createContext<CuriosityManagerProviderProps>(
  {} as CuriosityManagerProviderProps
);

export default function CuriosityManagerProvider({
  commonData,
  localization,
  curiosityParams,
  children,
}: {
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  children: React.ReactNode;
}) {
  const curiosityClickEvents = useMemo(
    () => createCuriosityClickEvents({ commonData, localization, curiosityParams }),
    [commonData, localization, curiosityParams]
  );
  const curiosityManagerContextValue = useMemo(() => ({ curiosityClickEvents }), [curiosityClickEvents]);

  return (
    <CuriosityManagerContext.Provider value={curiosityManagerContextValue}>{children}</CuriosityManagerContext.Provider>
  );
}

export const useCuriosityManager = () => React.useContext(CuriosityManagerContext);
